import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';

const Layout = ({ children }) => {
    const location = useLocation();
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);
    const showSidebar = !['/login', '/admin', '/signup', '/forgot-password'].includes(location.pathname);
    const sidebarWidth = isSidebarCollapsed ? 64 : 180;

    return (
        <Box sx={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
            {showSidebar && (
                <Sidebar
                    isCollapsed={isSidebarCollapsed}
                    onToggle={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
                />
            )}
            <Box
                sx={{
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    width: showSidebar ? `calc(100% - 64px)` : '100%',
                    marginLeft: showSidebar ? '0.5rem' : 0,
                    transition: 'margin-left 0.3s ease, width 0.3s ease',
                    overflow: 'hidden'
                }}
            >
                {showSidebar && <Header isSidebarCollapsed={isSidebarCollapsed} />}
                <Box sx={{
                    flexGrow: 1,
                    overflowY: 'auto',
                    height: showSidebar ? 'calc(100vh - 64px)' : '100vh',
                    marginTop: showSidebar ? '64px' : 0
                }}>
                    {children}
                </Box>
            </Box>
        </Box>
    );
};

export default Layout;
